import { apiFetch } from "./client";
import type { FolderCreateResponse, FolderDTO } from "./types";

export async function createFolder(input: {
  name: string;
  parentId: string | null;
}): Promise<FolderDTO> {
  const res = await apiFetch<FolderCreateResponse>("/api/folders", {
    method: "POST",
    body: JSON.stringify(input),
  });
  return res.folder;
}
